import { Record } from 'immutable';

export default class RecruitmentAdContactRecord extends Record({
  id: undefined,
  email: undefined,
  firstName: undefined,
  lastName: undefined,
  phone: undefined,
  title: undefined,
}) {
}
